/**
 * Типы тегов кэша пакета AQSI. Каждый ресурсный запрос отдаёт тег с rid
 * (`resourceTag`/`resourceListTag`) и тег области `resourceScopeTag(rid)`:
 * сброс AQSI-A не перечитывает AQSI-B.
 */
export const AQSI_TAGS = {
  registers: 'AqsiRegisters',
  journal: 'AqsiSessionJournal',
  /** С3: связь кассы двумя уровнями — сервер AQSI и аппарат. */
  link: 'AqsiRegisterLink',
  shift: 'AqsiShift',
  printSettings: 'AqsiPrintSettings',
  /** RP-SYN12: «Создание по умолчанию» ресурса. */
  createDefaults: 'AqsiCreateDefaults',
  operation: 'AqsiOperation',
  goods: 'AqsiGoods',
  /** RP-SE12: отдельный индекс поиска по снимку кабинета: результаты поиска и состояние индекса. */
  probe: 'AqsiProbeSearch',
  probeStatus: 'AqsiProbeStatus',
  /** RP-SE13: свежесть каталога кабинета - полоса «Источники» в «Номенклатуре». */
  freshness: 'AqsiFreshness',
  taxSummary: 'AqsiTaxSummary',
  devices: 'AqsiDevices',
  cashiers: 'AqsiCashiers',
  /** RP-FB22: кассиры источника для входа в РМК (`pos/cashiers`) — живое чтение, не снимок каталога. */
  posCashiers: 'AqsiPosCashiers',
  // UC1c: продажа и снимок реквизитов.
  sale: 'AqsiSale',
  saleActive: 'AqsiSaleActive',
  saleFiscal: 'AqsiSaleFiscal',
  /** С2: проверка корзины до оплаты. */
  saleCheck: 'AqsiSaleCheck',
  // UI-RMK: отложенные чеки кассы — на сервере рядом с продажей.
  heldCarts: 'AqsiHeldCarts',
  /** RP-FB35 K7: продажи ресурса, требующие внимания (`sales/attention`). */
  saleAttention: 'AqsiSaleAttention',
  /** RP-FB35 K9: отложенные продажи (деньги взяты) и их число. */
  saleParked: 'AqsiSaleParked',
  // UC1d: возврат, журнал инцидентов, доказательство восстановления, расхождения чеков.
  refund: 'AqsiRefund',
  incidents: 'AqsiIncidents',
  recoveryProof: 'AqsiRecoveryProof',
  discrepancies: 'AqsiDiscrepancies',
  /** RP-SALE-TRACE: диагностика продаж — список последних продаж и разбор одной. */
  trace: 'AqsiTrace',
  traceDeep: 'AqsiTraceDeep',
  /** Журнал обмена продажи с кабинетом: что отправлено и что ответил кабинет. */
  saleExchanges: 'AqsiSaleExchanges',
  /** RP-CASH-RECOVERY: «Проверка в AQSI» продажи — живое чтение службой, одно действие. */
  saleAqsiState: 'AqsiSaleAqsiState',
} as const

export const AQSI_TAG_TYPES: readonly string[] = Object.values(AQSI_TAGS)
